import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/d0884d08-4d4d-4247-97ef-a8a05946bb3f";
export const REGISTER_URL = "https://a.ntrk2.com/fda12da5-2572-45e4-84fd-75d5f4b2f256";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://bestbd.kzw2a.com/download?openExternalBrowser=1&id=gd778qcqqatj5g9";

export * from "./codes";
export * from "./context";
